export const THEME_PRESETS = {
  indigo: { label: "Judicial Navy (default)", h: 222, s: 60, l: 28 },
  odyssey: { label: "Odyssey Blue", h: 208, s: 61, l: 47 },
  navy: { label: "Navy", h: 218, s: 55, l: 34 },
  teal: { label: "Teal", h: 174, s: 58, l: 34 },
  forest: { label: "Forest Green", h: 150, s: 45, l: 32 },
  burgundy: { label: "Burgundy", h: 350, s: 58, l: 36 },
  slate: { label: "Charcoal Slate", h: 215, s: 24, l: 34 },
  plum: { label: "Plum", h: 285, s: 38, l: 40 },
  copper: { label: "Copper", h: 24, s: 58, l: 42 },
};

export const FONT_OPTIONS = [{ name: "Court reference — Arial / Times", google: null }];

export const hsl = (h, s, l) => `hsl(${h} ${Math.round(s)}% ${Math.round(Math.max(0, Math.min(100, l)))}%)`;

export function themeVars(presetKey) {
  const { h, s, l } = THEME_PRESETS[presetKey] || THEME_PRESETS.indigo;
  return {
    "--primary": `${h} ${s}% ${l}%`,
    "--ring": `${h} ${s}% ${l}%`,
    "--secondary-foreground": `${h} ${Math.max(0, s - 7)}% ${l - 14}%`,
    "--ujms-primary": hsl(h, s, l),
    "--ujms-primary-dark": hsl(h, s, l - 8),
    "--ujms-primary-deep": hsl(h, s, l - 22),
    "--ujms-primary-light": hsl(h, s, l + 8),
    "--ujms-title-top": hsl(h, s, l + 3),
    "--ujms-title-bottom": hsl(h, s, l - 20),
    "--ujms-tab-top": hsl(h, s * 0.7, 84),
    "--ujms-tab-bottom": hsl(h, s * 0.7, 74),
    "--ujms-tab-text": hsl(h, s, 30),
    "--ujms-tab-border": hsl(h, s * 0.6, 62),
    "--ujms-sec-top": hsl(h, s * 0.55, 78),
    "--ujms-sec-bottom": hsl(h, s * 0.55, 67),
    "--ujms-sec-border": hsl(h, s * 0.5, 60),
    "--ujms-soft": hsl(h, 55, 96),
    "--ujms-tint": hsl(h, 55, 90),
  };
}

/** Shared court typography, consistent across all workspaces. */
export function applyFont() {
  document.documentElement.style.setProperty("--ujms-font", "Arial, 'CJMS Reference Sans', Helvetica, sans-serif");
  document.documentElement.style.setProperty("--ujms-font-heading", "'Times New Roman', 'CJMS Reference Serif', Times, serif");
  document.documentElement.style.setProperty("--ujms-font-serif", "'Times New Roman', 'CJMS Reference Serif', Times, serif");
}

export function applyTheme(brand) {
  const root = document.documentElement;
  Object.entries(themeVars(brand?.theme_preset)).forEach(([k, v]) => root.style.setProperty(k, String(v)));
  applyFont(brand?.theme_font);
}

export function themeGradient(presetKey) {
  const { h, s, l } = THEME_PRESETS[presetKey] || THEME_PRESETS.indigo;
  return `linear-gradient(135deg, ${hsl(h, s, l + 6)} 0%, ${hsl(h, s, l - 24)} 100%)`;
}

const SCALES_PATH = "M16 6v20M9 26h14M16 6l-7 5M16 6l7 5M4 18l5-7 5 7c0 2.5-2.2 4-5 4s-5-1.5-5-4zm14 0l5-7 5 7c0 2.5-2.2 4-5 4s-5-1.5-5-4z";

export function faviconDataUrl(presetKey) {
  const { h, s, l } = THEME_PRESETS[presetKey] || THEME_PRESETS.indigo;
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><defs><linearGradient id="g" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="${hsl(h, s, l + 8)}"/><stop offset="1" stop-color="${hsl(h, s, l - 18)}"/></linearGradient></defs><circle cx="16" cy="16" r="15" fill="url(#g)"/><circle cx="16" cy="16" r="15" fill="none" stroke="white" stroke-opacity=".55" stroke-width="1.5"/><path d="${SCALES_PATH}" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
}

export function applyFavicon(href) {
  let link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.type = href.startsWith("data:image/svg") ? "image/svg+xml" : "";
  link.href = href;
  const apple = document.querySelector("link[rel='apple-touch-icon']");
  if (apple) apple.href = href;
}
